import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useTenantStore } from '@/stores'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { Plan } from '@core/models'
import { BetaFreePlan } from '@core/models'

interface TenantDrawerProps {
  open: boolean
  onClose: () => void
}

const TenantDrawer = observer(({ open, onClose }: TenantDrawerProps) => {
  const tenantStore = useTenantStore()
  const [name, setName] = useState('')
  const [plan, setPlan] = useState<Plan>(BetaFreePlan)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const result = await tenantStore.createTenant({ name, plan })
    if (result) {
      setName('')
      setPlan(BetaFreePlan)
      onClose()
    }
  }

  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>新規テナント作成</SheetTitle>
          <SheetDescription>
            新しいテナントの情報を入力してください
          </SheetDescription>
        </SheetHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-6">
          <div className="space-y-2">
            <Label htmlFor="name">テナント名</Label>
            <Input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="テナント名を入力"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="plan">プラン</Label>
            <Select value={String(plan)} onValueChange={(value) => setPlan(Number(value) as Plan)}>
              <SelectTrigger id="plan">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value={String(BetaFreePlan)}>βフリープラン</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              キャンセル
            </Button>
            <Button
              type="submit"
              className="flex-1"
              disabled={tenantStore.isLoading}
            >
              {tenantStore.isLoading ? '作成中...' : '作成'}
            </Button>
          </div>
        </form>
      </SheetContent>
    </Sheet>
  )
})

export default TenantDrawer